import NavBar from '../navbar/navbar';
import { FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, SxProps, Theme } from '@mui/material';
import { H2, Button } from '../reusable-components';
import { useTranslation } from 'react-i18next';
import useShallowRounds from '../rounds/useShallowRounds';
import React from 'react';
import { getDateString, getRoundName } from '../common/RoundHelper';
import FreeBetCoupon from './freebetcoupon';
import useFreebets from '../syndicates/useFreebets';


export default function FreeBetView({ freebetId }: { freebetId: string }) {
  const { t } = useTranslation();
  const [active] = useShallowRounds(true, false, 0);
  let [selectedRoundId, setSelectedRoundId] = React.useState<number>(0);
  let [getProPick, setGetProPick] = React.useState(0);
  const freebets = useFreebets();

  const activeRounds = active && active.rounds.filter(round => (round.status === 'ACTIVE' || round.status === 'PAUSED')
    && new Date(round.openTo) > new Date()
    && round.name.indexOf("Survivor") === -1);

  const freebet = freebets?.find(f => String(f.id) === freebetId);

  const theme = getComputedStyle(document.documentElement).getPropertyValue("--theme-name");

  const style: SxProps<Theme> = {
    background: "var(--background_1)",
    paddingTop: "20px",
    alignItems: "center",
    paddingBottom: "300px"
  }

  const handleChange = (event: SelectChangeEvent<number>) => {
    setSelectedRoundId(event.target.value as number)
  }

  const updateProPick = () => {
    setGetProPick((old) => old + 1)
  }

  if (freebet === undefined) {
    return <></>;
  }

  return (
    <>
      <NavBar whichToUnderline="0" balanceUpdateId="0" />
      <Grid sx={style} container direction="column">
        <H2>{freebet.name}</H2>

        <FormControl sx={{ minWidth: "300px", margin: "40px" }}>
          <InputLabel key="select-label" id="select-label" sx={{ color: "var(--text-black)", "&.Mui-focused": { color: "var(--text-black)" } }}>Välj omgång</InputLabel>
          <Select
            labelId="select-label"
            aria-labelledby="select-label"
            id="select"
            label="Välj omgång"
            value={selectedRoundId}
            onChange={(event) => handleChange(event)}
            sx={{
              color: "var(--text-black)",
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--text-black)" },
              "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "var(--text-black)" },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "var(--text-black)" },
              "& .MuiSvgIcon-root": { color: "var(--text-black)" },
            }}
          >

            <MenuItem key={"round" + 0} value={0}>Välj</MenuItem>
            {
              activeRounds?.map((round, index) =>
                <MenuItem key={"round" + index} value={round.id}>{getRoundName(round, t) + " - " + getDateString(round, t)}</MenuItem>
              )

            }
          </Select>
        </FormControl>

        <Grid container direction="column" marginTop="0px" alignItems="center">
          {selectedRoundId !== 0 &&
            <Grid sx={{marginBottom:"20px"}}>
              <Button onClick={() => updateProPick()}>{t('fill_automatic')}</Button>
            </Grid>
          }
          <FreeBetCoupon roundId={selectedRoundId} theme={theme} freebet={freebet} getProPick={getProPick} setGetProPick={setGetProPick}/>
        </Grid>


      </Grid>
    </>
  );
}
